import { type LeftSide, leftSideActions } from '@appStore/reducers/leftSideMenu'
import pageIcon from 'assets/image/icons/left-side-menu/page.svg'
import archiveIcon from 'assets/image/icons/svg/archive-icon-yellow.svg'
import turnIcon from 'assets/image/icons/svg/turn.svg'
import { useEffect } from 'react'
import { useActionCreators } from 'shared/hooks'

import { api } from '../api'
import { RECENT_PARAMS } from '../const'

const BOTTOM_LIST: LeftSide['bottomList'] = [
	{
		id: 2,
		image: turnIcon,
		link: '/activities-queue',
		title: 'Activities queue'
	},
	{
		id: 1,
		image: pageIcon,
		link: '/campaigns',
		title: 'All campaigns list'
	},
	{
		id: 3,
		image: archiveIcon,
		link: '/archive',
		title: 'Archive'
	}
]

const makeList = (list: LeftSide['list'] = []): LeftSide => ({
	bottomList: BOTTOM_LIST,
	label: 'Recently created',
	list,
	type: 'campaign'
})

export function useLoadList() {
	const { setLeftSide } = useActionCreators(leftSideActions)

	const campaignsQuery = api.useCampaignsPageQuery(RECENT_PARAMS)

	useEffect(() => {
		const list = makeList(campaignsQuery.data?.documents)
		setLeftSide(list as unknown as any)
	}, [campaignsQuery.data?.documents, setLeftSide])
}
